import { FC } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { FeedAuthorPageInner } from 'components/features/socialFeed/FeedAuthorPage/FeedAuthorPageInner'
import NavigationRedirect from 'components/atoms/navigation/NavigationRedirect'
import { OnboardingStepGuard } from 'components/features/pfm/OnboardingStepGuard/OnboardingStepGuard'
import { FeedGuard } from 'components/features/socialFeed/FeedGuard/FeedGuard'

type AuthorPageParams = {
  authorName: string
}

type FeedAuthorPageProps = Pick<RouteComponentProps<AuthorPageParams>, 'match'>

export const FeedAuthorPage: FC<FeedAuthorPageProps> = (props) => {
  const { match } = props

  const username = match.params.authorName

  if (!username) {
    return (
      <NavigationRedirect to='feedposts' />
    )
  }

  return (
    <FeedGuard>
      <OnboardingStepGuard>
        <FeedAuthorPageInner type='user' name={ username } />
      </OnboardingStepGuard>
    </FeedGuard>
  )
}
